import { ASR_Languages } from '../../models/callModel';
import { Types }from '../action/action';

const initialState = {
  list: [],
  asr_mic_lan:'en',
  asr_speaker_lan:'en',
  voice_speaker_lan:'en'
};

export const ASR_Language = (state:ASR_Languages = initialState, action: any) => {
  const {
    type,
    payloads
  } = action;
  switch (type) {
  case Types.ASR_LANGUAGES:
    return {
      ...state, list: payloads
    };
  case Types.ASR_MIC_DEFAULT:
    return {
      ...state, asr_mic_lan: payloads
    };
  case Types.ASR_SPEAKER_DEFAULT:
    return {
      ...state, asr_speaker_lan: payloads
    };
  case Types.VOICE_SPEAKER_DEFAULT:
    return {
      ...state, voice_speaker_lan: payloads
    };
  default:
    return state;
  };
};